import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    height: ${props =>(props.$fullScreen ? '300px' : '200px')};;
    width: 100%;
`;

export const NoDataContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
`

export const NoDataText = styled.span`
    color: #333;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
`;